import { useState } from "react";
import { Stack } from "@mui/material";
import { Share, TableChart, AttachMoney, Toc } from "@mui/icons-material";

import DealsDialog from "./DealsDialog";
import { people } from "./people";
import type { SeatProps } from "./types";

const departmentColorMap: Record<string, string> = {
  National: "rgba(34, 197, 94, 0.16)", // #d0f0c0
  Residential: "rgba(0, 184, 217, 0.16)", // #cce5ff
  "Post Closing": "rgba(255, 249, 196, 0.6)", // #fff9c4
  NY: "rgba(255, 205, 210, 0.6)", // #ffcdd2
  Texas: "rgba(230, 204, 178, 0.6)", // #e6ccb2
  Other: "rgba(150, 150, 150, 0.2)",
  JV: "rgba(186, 104, 200, 0.2)" // #ba68c8
};

export default function Seat({
  person,
  activePerson,
  border = [],
  position,
  onHighlightFunders,
  orders,
  relationshipsMap
}: SeatProps) {
  const [showModal, setShowModal] = useState(false);
  const hasRelationships = relationshipsMap[person?.name || ""] || [];

  const isPerson = Boolean(person?.id);
  const isEmpty = !person?.name?.trim();
  const backgroundColor = person?.department ? departmentColorMap[person.department] : undefined;
  const isActive = isPerson && person?.name === activePerson?.name;
  const isRelatedToActive =
    isPerson && activePerson?.name && Boolean(relationshipsMap[activePerson.name].includes(person?.name || ""));
  const inActive = Boolean(activePerson) && !isRelatedToActive && !isActive;

  const className = [
    "seat",
    isEmpty && "empty",
    inActive && "inactive",
    isActive && "active",
    isRelatedToActive && "funder",
    ...border
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <>
      <div className={className} style={{ gridColumn: position.col, gridRow: position.row }}>
        <div className="innerSeat" style={{ backgroundColor }}>
          <div>{isEmpty ? "" : person?.name}</div>
          {!isEmpty && (
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1 }}>
              {orders.length > 0 && <TableChart fontSize="small" onClick={() => setShowModal(true)} />}
              {hasRelationships.length > 0 ? (
                <AttachMoney
                  fontSize="small"
                  onClick={(e) => {
                    onHighlightFunders?.(person!);
                  }}
                />
              ) : (
                <span style={{ width: 16 }} />
              )}
            </Stack>
          )}
        </div>
      </div>

      <DealsDialog open={showModal} onClose={() => setShowModal(false)} orders={orders} />
    </>
  );
}
